import { useTheme } from '../../theme/theme-context';

/**
 * Header control that flips between the light and dark themes.
 *
 * The label names the action ("Switch to dark theme") and the icon shows the theme
 * it switches to, so the button reads the same to sighted and screen-reader users.
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={`Switch to ${next} theme`}
      className="flex size-10 shrink-0 items-center justify-center rounded-md border border-line-subtle text-ink-secondary transition-colors duration-150 hover:border-line-strong hover:text-ink-primary"
    >
      <span className="sr-only">{`Switch to ${next} theme`}</span>
      {next === 'dark' ? MOON_ICON : SUN_ICON}
    </button>
  );
}

const MOON_ICON = (
  <svg
    viewBox="0 0 20 20"
    className="size-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    aria-hidden="true"
  >
    <path
      d="M16.5 12.2A7 7 0 0 1 7.8 3.5a7 7 0 1 0 8.7 8.7Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SUN_ICON = (
  <svg
    viewBox="0 0 20 20"
    className="size-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="3.25" />
    <path
      d="M10 2.5v1.75M10 15.75v1.75M2.5 10h1.75M15.75 10h1.75M4.7 4.7l1.24 1.24M14.06 14.06l1.24 1.24M4.7 15.3l1.24-1.24M14.06 5.94l1.24-1.24"
      strokeLinecap="round"
    />
  </svg>
);
